import Vue from 'vue'
import Router from 'vue-router'
import {store} from '@/vuex/store.js';
let _this = new Vue({
  store
});
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    { // pc首页
      path: '/',
      name: '',
      redirect: '/homeP',
      component: resolve => {
        require(['@/components/pc/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc首页
      path: '/homeP',
      name: 'pcHome',
      component: resolve => {
        require(['@/components/pc/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc登录页
      path: '/loginP',
      name: 'pcLogin',
      component: resolve => {
        require(['@/components/pc/pages/login/Login.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc注册页
      path: '/signinP',
      name: 'pcSignin',
      component: resolve => {
        require(['@/components/pc/pages/login/Signin.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc提交基本信息页
      path: '/submitInformationP',
      name: 'pcSubmitInformation',
      component: resolve => {
        require(['@/components/pc/pages/login/SubmitInformation.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: true
      }
    },
    { // pc快捷套餐
      path: '/quickSetMealP',
      name: 'pcQuickSetMeal',
      component: resolve => {
        require(['@/components/pc/pages/quick-set-meal/QuickSetMeal.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc严选商城
      path: '/strictlySelectedMallP',
      name: 'pcStrictlySelectedMall',
      component: resolve => {
        require(['@/components/pc/pages/strictly-selected-mall/StrictlySelectedMall.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc企业应用
      path: '/companyApplicationP',
      name: 'pcCompanyApplication',
      component: resolve => {
        require(['@/components/pc/pages/company-application/CompanyApplication.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc企业应用-产品列表
      path: '/companyProductListP',
      name: 'pcCompanyProductList',
      component: resolve => {
        require(['@/components/pc/pages/company-application/CompanyProductList.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc企业应用-服务商产品列表/简介
      path: '/facilitatorGoodsListP',
      name: 'pcFacilitatorGoodsList',
      component: resolve => {
        require(['@/components/pc/pages/company-application/FacilitatorGoodsList.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc企业应用-产品列表-产品详情
      path: '/goodsDetailP',
      name: 'pcGoodsDetail',
      component: resolve => {
        require(['@/components/pc/pages/company-application/GoodsDetail.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc开发者
      path: '/developerP',
      name: 'pcDeveloper',
      component: resolve => {
        require(['@/components/pc/pages/developer/Developer.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc解决方案
      path: '/solutionP',
      name: 'pcSolution',
      component: resolve => {
        require(['@/components/pc/pages/solution/Solution.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc政策扶持
      path: '/policiesSupportP',
      name: 'pcPoliciesSupport',
      component: resolve => {
        require(['@/components/pc/pages/policies-support/PoliciesSupport.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc文章详情
      path: '/articleDetailP',
      name: 'pcArticleDetail',
      component: resolve => {
        require(['@/components/pc/pages/article-detail/ArticleDetail.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc伙伴计划
      path: '/partnerPlanP',
      name: 'pcPartnerPlan',
      component: resolve => {
        require(['@/components/pc/pages/partner-plan/PartnerPlan.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc伙伴计划-申请加入
      path: '/partnerJoinP',
      name: 'pcPartnerJoin',
      component: resolve => {
        require(['@/components/pc/pages/partner-plan/PartnerJoin.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc服务商列表
      path: '/facilitatorListP',
      name: 'pcFacilitatorList',
      component: resolve => {
        require(['@/components/pc/pages/facilitator/FacilitatorList.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc课程列表
      path: '/courseListP',
      name: 'pcCourseList',
      component: resolve => {
        require(['@/components/pc/pages/course/CourseList.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc课程列表-课程详情
      path: '/courseDetailP',
      name: 'pcCourseDetail',
      component: resolve => {
        require(['@/components/pc/pages/course/CourseDetail.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc提交订单
      path: '/commitOrderP',
      name: 'pcCommitOrder',
      component: resolve => {
        require(['@/components/pc/pages/buy/CommitOrder.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc提交订单-立即付款
      path: '/nowPayP',
      name: 'pcNowPay',
      component: resolve => {
        require(['@/components/pc/pages/buy/NowPay.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc提交订单-立即付款-购买结果
      path: '/payResultP',
      name: 'pcPayResult',
      component: resolve => {
        require(['@/components/pc/pages/buy/PayResult.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // pc搜索页
      path: '/searchP',
      name: 'pcSearch',
      component: resolve => {
        require(['@/components/pc/pages/search/Search.vue'], resolve)
      },
      meta: {
        isMobile: false,
        needLogin: false
      }
    },
    { // app首页
      path: '/homeM',
      name: 'appHome',
      component: resolve => {
        require(['@/components/mobile/pages/home/Home.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app注册页
      path: '/signinM',
      name: 'appSignin',
      component: resolve => {
        require(['@/components/mobile/pages/login/Signin.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app登录页
      path: '/loginM',
      name: 'appLogin',
      component: resolve => {
        require(['@/components/mobile/pages/login/Login.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app提交基本信息页
      path: '/submitInformationM',
      name: 'appSubmitInformation',
      component: resolve => {
        require(['@/components/mobile/pages/login/SubmitInformation.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: true
      }
    },
    { // app快捷套餐
      path: '/quickSetMealM',
      name: 'appQuickSetMeal',
      component: resolve => {
        require(['@/components/mobile/pages/quick-set-meal/QuickSetMeal.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app严选商城
      path: '/strictlySelectedMallM',
      name: 'appStrictlySelectedMall',
      component: resolve => {
        require(['@/components/mobile/pages/strictly-selected-mall/StrictlySelectedMall.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app企业应用
      path: '/companyApplicationM',
      name: 'appCompanyApplication',
      component: resolve => {
        require(['@/components/mobile/pages/company-application/CompanyApplication.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app企业应用-产品列表
      path: '/companyProductListM',
      name: 'appCompanyProductList',
      component: resolve => {
        require(['@/components/mobile/pages/company-application/CompanyProductList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app企业应用-产品列表-产品详情
      path: '/goodsDetailM',
      name: 'appGoodsDetail',
      component: resolve => {
        require(['@/components/mobile/pages/company-application/GoodsDetail.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app企业应用-服务商产品列表/简介
      path: '/facilitatorGoodsListM',
      name: 'appFacilitatorGoodsList',
      component: resolve => {
        require(['@/components/mobile/pages/company-application/FacilitatorGoodsList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app开发者
      path: '/developerM',
      name: 'appDeveloper',
      component: resolve => {
        require(['@/components/mobile/pages/developer/Developer.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app解决方案
      path: '/solutionM',
      name: 'appSolution',
      component: resolve => {
        require(['@/components/mobile/pages/solution/Solution.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app政策扶持
      path: '/policiesSupportM',
      name: 'appPoliciesSupport',
      component: resolve => {
        require(['@/components/mobile/pages/policies-support/PoliciesSupport.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app文章详情
      path: '/articleDetailM',
      name: 'appArticleDetail',
      component: resolve => {
        require(['@/components/mobile/pages/article-detail/ArticleDetail.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app伙伴计划
      path: '/partnerPlanM',
      name: 'appPartnerPlan',
      component: resolve => {
        require(['@/components/mobile/pages/partner-plan/PartnerPlan.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app伙伴计划-申请加入
      path: '/partnerJoinM',
      name: 'appPartnerJoin',
      component: resolve => {
        require(['@/components/mobile/pages/partner-plan/PartnerJoin.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app服务商列表
      path: '/facilitatorListM',
      name: 'appFacilitatorList',
      component: resolve => {
        require(['@/components/mobile/pages/facilitator/FacilitatorList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app课程列表
      path: '/courseListM',
      name: 'appCourseList',
      component: resolve => {
        require(['@/components/mobile/pages/course/CourseList.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app课程列表-课程详情
      path: '/courseDetailM',
      name: 'appCourseDetail',
      component: resolve => {
        require(['@/components/mobile/pages/course/CourseDetail.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app提交订单
      path: '/commitOrderM',
      name: 'appCommitOrder',
      component: resolve => {
        require(['@/components/mobile/pages/buy/CommitOrder.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
    { // app提交订单-立即付款-购买结果
      path: '/payResultM',
      name: 'appPayResult',
      component: resolve => {
        require(['@/components/mobile/pages/buy/PayResult.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: true
      }
    },
    { // app搜索页
      path: '/searchM',
      name: 'appSearch',
      component: resolve => {
        require(['@/components/mobile/pages/search/Search.vue'], resolve)
      },
      meta: {
        isMobile: true,
        needLogin: false
      }
    },
  ]
});
router.beforeEach((to, form, next) => {
  let isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent); // pc/移动终端判断
  _this.$store.commit('setEquipmentInfo', {isMobile: isMobile});
  let toPageData = to.fullPath.split('?')[1]; // 去的页面所携带的参数
  // true 去PC端,false 去移动端
  if(!to.meta.isMobile) { // 去pc端路径，判断当前设备
    if(isMobile) { // 在移动端想去pc端，判断去的页面是否需要登录
      let toPath = to.path.substring(0, to.path.length - 1), 
          path = toPageData ? `${toPath}M?${toPageData}` : `${toPath}M`; // 去的页面路径
      if(to.path == '/') {
        return next({ path: '/homeM' });
      }
      if(to.meta.needLogin) { // 需要登录，判断是否登录
        if(window.localStorage.getItem('token')) {
          return next({ path: path }); // 已登录，通过
        } else {
          return next({path: form.fullPath}); // 没有登录，返回来的页面
        }
      }
      return next({ path: path }); // 不需要登录，通过
    } else { // 在pc端去pc端，判断去的页面是否需要登录
      // let tofullpath = to.fullPath == 'homeP' ? '/' : to.fullPath;
      // window.sessionStorage.setItem('currentPageName', JSON.stringify({path: tofullpath})); // 保存当前页，登录时用
      if(to.meta.needLogin) { // 需要登录，判断是否登录
        if(window.localStorage.getItem('token')) {
          return next(); // 已登录，通过
        } else {
          return next({path: form.fullPath}); // 没有登录，返回来的页面
        }
      }
      return next(); // 不需要登录，通过
    }
  } else { // 去移动端路径，判断当前设备
    if(isMobile) { // 在移动端去移动端，判断去的页面是否需要登录
      if(to.meta.needLogin) { // 需要登录，判断是否登录
        if(window.localStorage.getItem('token')) {
          return next(); // 已登录，通过
        } else {
          return next({path: form.fullPath}); // 没有登录，返回来的页面
        }
      }
      return next(); // 不需要登录，通过
    } else { // 在pc端想去移动端，判断去的页面是否需要登录
      let toPath = to.path.substring(0, to.path.length - 1), 
          path = toPageData ? `${toPath}P?${toPageData}` : `${toPath}P`;
      // window.sessionStorage.setItem('currentPageName', JSON.stringify({path: path})); // 保存当前页，登录时用
      // let path = toPageData ? `${toPath}P?${toPageData}` : `${toPath}P`;
      if(to.meta.needLogin) { // 需要登录，判断是否登录
        if(window.localStorage.getItem('token')) {
          return next({ path: path }); // 已登录，通过
        } else {
          return next({path: form.fullPath}); // 没有登录，返回来的页面
        }
      }
      return next({ path: path }); // 不需要登录，通过
    }
  }
});

export default router




// WEBPACK FOOTER //
// ./src/router/index.js